import React from 'react';
import styled from 'react-emotion';
import Helmet from 'react-helmet';
import Panel from 'components/panel';
import pageImage from './frontpage.jpg';

const Page = styled('div')({
  label: 'page',
  margin: '0 10px',
  borderRadius: '20px',
  padding: '10px',
  display: 'flex',
  position: 'relative',
  flexGrow: 1,
  zIndex: 3,
}, ({ theme }) => ({
  backgroundColor: theme.page.backgroundColor,
  color: theme.page.textColor,
  ...theme.media.grid({ margin: 0 })
}));

const Content = styled('div')({
  label: 'page-content',
  display: 'flex',
  flexGrow: 1,
  position: 'absolute',
  top: '10px',
  bottom: '10px',
  left: '10px',
  right: '10px',
  ':first-child': {
    flexGrow: 1,
  }
});

const Image = styled('div')({
  flexGrow: 1,
  backgroundImage: `url(${pageImage})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
});

const Background = styled('div')({
  label: 'page-background',
  position: 'absolute',
  top: '10px',
  bottom: '10px',
  left: '10px',
  right: '10px',
  display: 'flex',
  flexDirection: 'column',
});

const PagePanel = styled(Panel)({
  marginTop: 0,
});

class PageContainer extends React.Component {

  handleHeaderChange = (newState) => {
    this.props.onSetTitle((newState.title || []).join(''));
  }

  render() {
    const { title, siteName, before , after, children, noPanel } = this.props;
    const After = after;
    const Before = before;

    return (
      <Page>
        {title &&
          <Helmet onChangeClientState={this.handleHeaderChange}><title>{title}{siteName ? ` - ${siteName}` : ''}</title></Helmet>}
        <Background>
          {Before && <Before />}
          <Image>&nbsp;</Image>
          {After && <After />}
        </Background>
        {noPanel ?
           children :
          <Content>
            <PagePanel title={title}>
              {children}
            </PagePanel>
          </Content>
        }
      </Page>
    );
  }
}

PageContainer.defaultProps = {
  onSetTitle: () => {},
};

export default PageContainer;



// WEBPACK FOOTER //
// ./src/structure/page/page.js